export default __webpack_public_path__ + "static/Row 2.2_Canossa Catholic-f96f11c39affd7526dc887f0488819d9.jpg";